// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  Status,
  StatusFromJSON,
  StatusToJSON,
  StatusCreatePayload,
  StatusCreatePayloadFromJSON,
  StatusCreatePayloadToJSON,
  StatusUpdatePayload,
  StatusUpdatePayloadFromJSON,
  StatusUpdatePayloadToJSON,
} from "../models";

export interface CreateStatusRequest {
  statusCreatePayload: StatusCreatePayload;
  project: number;
}

export interface DeleteStatusByIdRequest {
  statusId: number;
  project?: number;
}

export interface GetStatusByIdRequest {
  statusId: number;
  project?: number;
}

export interface GetStatusesRequest {
  project: number;
  isActive?: boolean;
  limit?: number;
  start?: number;
  sort?: string;
}

export interface UpdateStatusByIdRequest {
  statusUpdatePayload: StatusUpdatePayload;
  statusId: number;
  project?: number;
}

/**
 * no description
 */
export class StatusesApi extends runtime.BaseAPI {
  /**
   * Adds a new custom status, associating it with a project specified in the payload or query.
   * Create a custom status
   */
  async createStatusRaw(
    requestParameters: CreateStatusRequest
  ): Promise<runtime.ApiResponse<Status>> {
    if (
      requestParameters.statusCreatePayload === null ||
      requestParameters.statusCreatePayload === undefined
    ) {
      throw new runtime.RequiredError(
        "statusCreatePayload",
        "Required parameter requestParameters.statusCreatePayload was null or undefined when calling createStatus."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling createStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/statuses`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: StatusCreatePayloadToJSON(requestParameters.statusCreatePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StatusFromJSON(jsonValue)
    );
  }

  /**
   * Adds a new custom status, associating it with a project specified in the payload or query.
   * Create a custom status
   */
  async createStatus(requestParameters: CreateStatusRequest): Promise<Status> {
    const response = await this.createStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Deletes a custom status. System statuses cannot be deleted. Project context might be required.
   * Delete a custom status by ID
   */
  async deleteStatusByIdRaw(
    requestParameters: DeleteStatusByIdRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.statusId === null ||
      requestParameters.statusId === undefined
    ) {
      throw new runtime.RequiredError(
        "statusId",
        "Required parameter requestParameters.statusId was null or undefined when calling deleteStatusById."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/statuses/{statusId}`.replace(
        `{${"statusId"}}`,
        encodeURIComponent(String(requestParameters.statusId))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Deletes a custom status. System statuses cannot be deleted. Project context might be required.
   * Delete a custom status by ID
   */
  async deleteStatusById(
    requestParameters: DeleteStatusByIdRequest
  ): Promise<void> {
    await this.deleteStatusByIdRaw(requestParameters);
  }

  /**
   * Retrieves details of a specific status by its ID. Project context might be required for authorization.
   * Get a specific status by ID
   */
  async getStatusByIdRaw(
    requestParameters: GetStatusByIdRequest
  ): Promise<runtime.ApiResponse<Status>> {
    if (
      requestParameters.statusId === null ||
      requestParameters.statusId === undefined
    ) {
      throw new runtime.RequiredError(
        "statusId",
        "Required parameter requestParameters.statusId was null or undefined when calling getStatusById."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/statuses/{statusId}`.replace(
        `{${"statusId"}}`,
        encodeURIComponent(String(requestParameters.statusId))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StatusFromJSON(jsonValue)
    );
  }

  /**
   * Retrieves details of a specific status by its ID. Project context might be required for authorization.
   * Get a specific status by ID
   */
  async getStatusById(
    requestParameters: GetStatusByIdRequest
  ): Promise<Status> {
    const response = await this.getStatusByIdRaw(requestParameters);
    return await response.value();
  }

  /**
   * Retrieves all statuses (system and custom), optionally filtered by project.
   * List statuses
   */
  async getStatusesRaw(
    requestParameters: GetStatusesRequest
  ): Promise<runtime.ApiResponse<Array<Status>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getStatuses."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.isActive !== undefined) {
      queryParameters["isActive"] = requestParameters.isActive;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/statuses`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(StatusFromJSON)
    );
  }

  /**
   * Retrieves all statuses (system and custom), optionally filtered by project.
   * List statuses
   */
  async getStatuses(
    requestParameters: GetStatusesRequest
  ): Promise<Array<Status>> {
    const response = await this.getStatusesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Updates an existing status. System statuses have restrictions. Project context might be required.
   * Update a status by ID
   */
  async updateStatusByIdRaw(
    requestParameters: UpdateStatusByIdRequest
  ): Promise<runtime.ApiResponse<Status>> {
    if (
      requestParameters.statusUpdatePayload === null ||
      requestParameters.statusUpdatePayload === undefined
    ) {
      throw new runtime.RequiredError(
        "statusUpdatePayload",
        "Required parameter requestParameters.statusUpdatePayload was null or undefined when calling updateStatusById."
      );
    }

    if (
      requestParameters.statusId === null ||
      requestParameters.statusId === undefined
    ) {
      throw new runtime.RequiredError(
        "statusId",
        "Required parameter requestParameters.statusId was null or undefined when calling updateStatusById."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/statuses/{statusId}`.replace(
        `{${"statusId"}}`,
        encodeURIComponent(String(requestParameters.statusId))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: StatusUpdatePayloadToJSON(requestParameters.statusUpdatePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StatusFromJSON(jsonValue)
    );
  }

  /**
   * Updates an existing status. System statuses have restrictions. Project context might be required.
   * Update a status by ID
   */
  async updateStatusById(
    requestParameters: UpdateStatusByIdRequest
  ): Promise<Status> {
    const response = await this.updateStatusByIdRaw(requestParameters);
    return await response.value();
  }
}
